<template>
  <div class="item-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item >{{DetailData.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="content-title">
        <span>{{DetailData.title}}</span>
        <p>{{DetailData.eventTime}}</p>
      </div>
      <div class="content-des">
        <pre>
          {{DetailData.mainDescription}}
        </pre>
      </div>
<!--      <div class="content-img" v-html="DetailData.description">-->
      <div class="content-img" v-html="DetailData.description">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail",
    data(){
      return{
        DetailData:{},
        url:''
      }
    },
    created() {
      this.GetData(this.$route.params.id)
    },

    methods:{
      GetData(id){
        this.$axios.get('/api/case/getById/'+id,).then(res=>{
          console.log(res)
          this.DetailData=res.data.data
          this.url = res.data.data.photoUrl
          console.log(this.DetailData.description)

        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .item-base{
    .header{
      height: 44px;
      background: #F6F7F8;
      .header-content{
        line-height: 44px;
        margin: 0 auto;
        width: 74.5%;
        /*padding:10px;*/
      }
    }
    .content{
      width: 62.5vw;
      margin: 0 auto;
      .content-title{
        min-height: 100px;
        border-bottom: 1px solid #DDDDDD;
        padding-top: 60px;
        span{
          display: block;
          height: 32px;
          font-size: 32px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 48px;
        }
        p{
          padding-top: 15px;
          height: 14px;
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #999999;
          line-height: 21px;

        }
      }
      .content-des{
        margin-top: 40px;
        pre{
          text-indent: 8px;
          white-space: pre-wrap;

          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 26px;

        }
      }
      .content-img{
        padding: 20px 0;
        pre{
          text-indent: 8px;
          white-space: pre-wrap;

          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 26px;

        }
        .img{
          margin-bottom: 10px;
          height: 550px;
        }
      }
    }
    .content-img {
      font-family: SourceHanSansCN-Bold, SourceHanSansCN !important;
    }
  }
</style>